(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-context.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-context.js');
"use strict";

const {
  createContext
} = React;
const HighscoreContext = createContext();
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighscoreContext', HighscoreContext);

 })(window);